import FileSaver from 'file-saver';

import { isEmpty } from 'lodash';

export const handleJSONResponse = ({ data }) => ({ data });

export const handleFileResponse = ({ rawData, headers }) => {
  const fileName = headers['content-disposition']
    .split('filename=')[1]
    .replace(/["']/g, '');
  const data = { file: rawData, fileName };

  return { data };
};

export const handleFileDownloadResponse = ({ rawData, headers }) => {
  const blob = new Blob([rawData], {
    type: 'text/plain;charset=utf-8',
  });
  const fileName = headers['content-disposition']
    .split('filename=')[1]
    .replace(/["']/g, '');

  const hasExtension = fileName.split('.').length > 1;

  const fileNameToDownload = hasExtension ? fileName : `${fileName}.csv`;
  FileSaver.saveAs(blob, fileNameToDownload);
};

export const handleFileDownloadResponseFromJSON = ({ data }) => {
  if (!isEmpty(data) && data?.url) {
    const fileName = data?.url?.split('/').pop().split('?')[0];
    FileSaver.saveAs(data?.url, fileName);
  }

  return { data };
};
